export default __webpack_public_path__ + "assets/audios/e883caf188cfb2571cf0939ab7bec0e9.mp3";